import { Tooltip } from "antd";
import React, { useState } from "react";

const DocumentCollectionData = ({ documentCollection, getColor }) => {
  const [showMore, setShowMore] = useState(true);
  const [showLess, setShowLess] = useState(false);

  const hexToRgba = (hex, opacity) => {
    hex = hex.replace("#", "");

    // Expand shorthand hex (#abc → #aabbcc)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const downloadFile = async (id, name) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}common/getDocumentFromDms?dms_id=${id}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) throw new Error("File fetch failed");

      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name || "downloaded_image.png"; 
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const downloadFileBySfResponse = async (id, name) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}common/getDocumentFromAttachmentId?attachment_id=${id.split('=')[1]}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) throw new Error("File fetch failed");
      const res = await response.json();

      const byteCharacters = atob(res.d.fileContent);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: res.d.mimeType });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name || "downloaded_image.png";
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      <div
        className="list-group-item d-flex align-items-start border-0 text-start mb-1"
        style={{
          background: "inherit",
          gap: "10px",
          padding: "0px",
          width: "100%",
        }}
      >
        <div
          className="d-flex flex-column"
          style={{ gap: "10px", width: "100%" }}
        >
          {showMore && documentCollection.length > 2
            ? documentCollection.slice(0, 2).map((doc, idx) => {
                let color = getColor(doc.status);
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #858B932E",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "12px",
                      maxWidth: "500px",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      fontFamily: "Arial, sans-serif",
                    }}
                    key={idx}
                  >
                    <div style={{ marginRight: "12px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="29"
                        viewBox="0 0 30 29"
                        fill="none"
                      >
                        <path
                          d="M4.20059 26.1999H6.90059V28.8999H4.20059C2.21496 28.8999 0.600586 27.2855 0.600586 25.2999V3.69985C0.600586 1.71423 2.21496 0.0998535 4.20059 0.0998535H13.51C14.4662 0.0998535 15.3831 0.476729 16.0581 1.15173L21.1487 6.24235C21.8237 6.91735 22.2006 7.83423 22.2006 8.79048V17.1999H19.5006V9.09985H15.0006C14.005 9.09985 13.2006 8.29548 13.2006 7.29985V2.79985H4.20059C3.70559 2.79985 3.30059 3.20485 3.30059 3.69985V25.2999C3.30059 25.7949 3.70559 26.1999 4.20059 26.1999ZM10.5006 19.8999H12.3006C13.7912 19.8999 15.0006 21.1092 15.0006 22.5999V26.1999C15.0006 27.6905 13.7912 28.8999 12.3006 28.8999H10.5006C10.0056 28.8999 9.60059 28.4949 9.60059 27.9999V20.7999C9.60059 20.3049 10.0056 19.8999 10.5006 19.8999ZM11.4006 27.0999H12.3006C12.7956 27.0999 13.2006 26.6949 13.2006 26.1999V22.5999C13.2006 22.1049 12.7956 21.6999 12.3006 21.6999H11.4006V27.0999ZM26.2506 19.8999H27.1506C28.3937 19.8999 29.4006 20.9067 29.4006 22.1499V22.5999C29.4006 23.0949 28.9956 23.4999 28.5006 23.4999C28.0056 23.4999 27.6006 23.0949 27.6006 22.5999V22.1499C27.6006 21.9024 27.3981 21.6999 27.1506 21.6999H26.2506C26.0031 21.6999 25.8006 21.9024 25.8006 22.1499V26.6499C25.8006 26.8974 26.0031 27.0999 26.2506 27.0999H27.1506C27.3981 27.0999 27.6006 26.8974 27.6006 26.6499V26.1999C27.6006 25.7049 28.0056 25.2999 28.5006 25.2999C28.9956 25.2999 29.4006 25.7049 29.4006 26.1999V26.6499C29.4006 27.893 28.3937 28.8999 27.1506 28.8999H26.2506C25.0075 28.8999 24.0006 27.893 24.0006 26.6499V22.1499C24.0006 20.9067 25.0075 19.8999 26.2506 19.8999ZM16.8006 22.1499C16.8006 20.9067 17.8075 19.8999 19.0506 19.8999H19.9506C21.1937 19.8999 22.2006 20.9067 22.2006 22.1499V26.6499C22.2006 27.893 21.1937 28.8999 19.9506 28.8999H19.0506C17.8075 28.8999 16.8006 27.893 16.8006 26.6499V22.1499ZM19.0506 21.6999C18.8031 21.6999 18.6006 21.9024 18.6006 22.1499V26.6499C18.6006 26.8974 18.8031 27.0999 19.0506 27.0999H19.9506C20.1981 27.0999 20.4006 26.8974 20.4006 26.6499V22.1499C20.4006 21.9024 20.1981 21.6999 19.9506 21.6999H19.0506Z"
                          fill="#487ED8"
                        />
                      </svg>
                    </div>

                    <div style={{ flexGrow: 1 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          marginBottom: "4px",
                        }}
                      >
                        {doc.doc_name}
                      </div>
                      {doc.comment && (
                        <div style={{ fontSize: "13px", color: "#6B7280" }}>
                          {doc.comment.length > 100 ? (
                            <Tooltip title={doc.comment} placement="top">
                              <span>{doc.comment.slice(0, 100)}...</span>
                            </Tooltip>
                          ) : (
                            <span>{doc.comment}</span>
                          )}
                        </div>
                      )}
                    </div>

                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ gap: "8px", width: "33%" }}
                    >
                      <div
                        style={{
                          backgroundColor: color
                            ? hexToRgba(color, 0.2)
                            : "#6f74900f",
                          color: color ? color : "#000",
                          fontSize: "12px",
                          fontWeight: 600,
                          padding: "4px 10px",
                          borderRadius: "12px",
                          marginLeft: "auto",
                        }}
                      >
                        {doc.status}
                      </div>

                      {doc.dms_id ? (
                        <button
                          onClick={() => downloadFile(doc.dms_id, doc.doc_name)}
                          style={{
                            backgroundColor: "#487ED8",
                            borderRadius: "10px",
                            border: "none",
                            padding: "7px 12px",
                            marginLeft: "auto",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                          >
                            <path
                              d="M-0.00976562 7.00001C-0.00976562 3.40829 2.90291 0.496106 6.4968 0.496106C10.0876 0.496106 13.0002 3.40829 13.0002 7.00001C13.0002 10.5925 10.0876 13.5039 6.4968 13.5039C2.90291 13.5039 -0.00976562 10.5925 -0.00976562 7.00001ZM9.74773 7.01275H7.30836V3.74806H5.68211V7.01275H3.25548L6.4968 10.2527L9.74773 7.01275Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      ) : doc.sf_response && (
                        <button
                          onClick={() => downloadFileBySfResponse(doc.sf_response, doc.doc_name)}
                          style={{
                            backgroundColor: "#487ED8",
                            borderRadius: "10px",
                            border: "none",
                            padding: "7px 12px",
                            marginLeft: "auto",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                          >
                            <path
                              d="M-0.00976562 7.00001C-0.00976562 3.40829 2.90291 0.496106 6.4968 0.496106C10.0876 0.496106 13.0002 3.40829 13.0002 7.00001C13.0002 10.5925 10.0876 13.5039 6.4968 13.5039C2.90291 13.5039 -0.00976562 10.5925 -0.00976562 7.00001ZM9.74773 7.01275H7.30836V3.74806H5.68211V7.01275H3.25548L6.4968 10.2527L9.74773 7.01275Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                );
              })
            : documentCollection.map((doc, idx) => {
                let color = getColor(doc.status);
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #858B932E",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "12px",
                      maxWidth: "500px",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      fontFamily: "Arial, sans-serif",
                    }}
                    key={idx}
                  >
                    <div style={{ marginRight: "12px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="29"
                        viewBox="0 0 30 29"
                        fill="none"
                      >
                        <path
                          d="M4.20059 26.1999H6.90059V28.8999H4.20059C2.21496 28.8999 0.600586 27.2855 0.600586 25.2999V3.69985C0.600586 1.71423 2.21496 0.0998535 4.20059 0.0998535H13.51C14.4662 0.0998535 15.3831 0.476729 16.0581 1.15173L21.1487 6.24235C21.8237 6.91735 22.2006 7.83423 22.2006 8.79048V17.1999H19.5006V9.09985H15.0006C14.005 9.09985 13.2006 8.29548 13.2006 7.29985V2.79985H4.20059C3.70559 2.79985 3.30059 3.20485 3.30059 3.69985V25.2999C3.30059 25.7949 3.70559 26.1999 4.20059 26.1999ZM10.5006 19.8999H12.3006C13.7912 19.8999 15.0006 21.1092 15.0006 22.5999V26.1999C15.0006 27.6905 13.7912 28.8999 12.3006 28.8999H10.5006C10.0056 28.8999 9.60059 28.4949 9.60059 27.9999V20.7999C9.60059 20.3049 10.0056 19.8999 10.5006 19.8999ZM11.4006 27.0999H12.3006C12.7956 27.0999 13.2006 26.6949 13.2006 26.1999V22.5999C13.2006 22.1049 12.7956 21.6999 12.3006 21.6999H11.4006V27.0999ZM26.2506 19.8999H27.1506C28.3937 19.8999 29.4006 20.9067 29.4006 22.1499V22.5999C29.4006 23.0949 28.9956 23.4999 28.5006 23.4999C28.0056 23.4999 27.6006 23.0949 27.6006 22.5999V22.1499C27.6006 21.9024 27.3981 21.6999 27.1506 21.6999H26.2506C26.0031 21.6999 25.8006 21.9024 25.8006 22.1499V26.6499C25.8006 26.8974 26.0031 27.0999 26.2506 27.0999H27.1506C27.3981 27.0999 27.6006 26.8974 27.6006 26.6499V26.1999C27.6006 25.7049 28.0056 25.2999 28.5006 25.2999C28.9956 25.2999 29.4006 25.7049 29.4006 26.1999V26.6499C29.4006 27.893 28.3937 28.8999 27.1506 28.8999H26.2506C25.0075 28.8999 24.0006 27.893 24.0006 26.6499V22.1499C24.0006 20.9067 25.0075 19.8999 26.2506 19.8999ZM16.8006 22.1499C16.8006 20.9067 17.8075 19.8999 19.0506 19.8999H19.9506C21.1937 19.8999 22.2006 20.9067 22.2006 22.1499V26.6499C22.2006 27.893 21.1937 28.8999 19.9506 28.8999H19.0506C17.8075 28.8999 16.8006 27.893 16.8006 26.6499V22.1499ZM19.0506 21.6999C18.8031 21.6999 18.6006 21.9024 18.6006 22.1499V26.6499C18.6006 26.8974 18.8031 27.0999 19.0506 27.0999H19.9506C20.1981 27.0999 20.4006 26.8974 20.4006 26.6499V22.1499C20.4006 21.9024 20.1981 21.6999 19.9506 21.6999H19.0506Z"
                          fill="#487ED8"
                        />
                      </svg>
                    </div>

                    <div style={{ flexGrow: 1 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          marginBottom: "4px",
                        }}
                      >
                        {doc.doc_name}
                      </div>
                      {doc.comment && (
                        <div style={{ fontSize: "13px", color: "#6B7280" }}>
                          {doc.comment.length > 100 ? (
                            <Tooltip title={doc.comment} placement="top">
                              <span>{doc.comment.slice(0, 100)}...</span>
                            </Tooltip>
                          ) : (
                            <span>{doc.comment}</span>
                          )}
                        </div>
                      )}
                    </div>

                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ gap: "8px", width: "33%" }}
                    >
                      <div
                        style={{
                          backgroundColor: color
                            ? hexToRgba(color, 0.2)
                            : "#6f74900f",
                          color: color ? color : "#000",
                          fontSize: "12px",
                          fontWeight: 600,
                          padding: "4px 10px",
                          borderRadius: "12px",
                          marginLeft: "auto",
                        }}
                      >
                        {doc.status}
                      </div>

                      {doc.dms_id ? (
                        <button
                          onClick={() => downloadFile(doc.dms_id, doc.doc_name)}
                          style={{
                            backgroundColor: "#487ED8",
                            borderRadius: "10px",
                            border: "none",
                            padding: "7px 12px",
                            marginLeft: "auto",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                          >
                            <path
                              d="M-0.00976562 7.00001C-0.00976562 3.40829 2.90291 0.496106 6.4968 0.496106C10.0876 0.496106 13.0002 3.40829 13.0002 7.00001C13.0002 10.5925 10.0876 13.5039 6.4968 13.5039C2.90291 13.5039 -0.00976562 10.5925 -0.00976562 7.00001ZM9.74773 7.01275H7.30836V3.74806H5.68211V7.01275H3.25548L6.4968 10.2527L9.74773 7.01275Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      ) : doc.sf_response && (
                        <button
                          onClick={() => downloadFileBySfResponse(doc.sf_response, doc.doc_name)}
                          style={{
                            backgroundColor: "#487ED8",
                            borderRadius: "10px",
                            border: "none",
                            padding: "7px 12px",
                            marginLeft: "auto",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                          >
                            <path
                              d="M-0.00976562 7.00001C-0.00976562 3.40829 2.90291 0.496106 6.4968 0.496106C10.0876 0.496106 13.0002 3.40829 13.0002 7.00001C13.0002 10.5925 10.0876 13.5039 6.4968 13.5039C2.90291 13.5039 -0.00976562 10.5925 -0.00976562 7.00001ZM9.74773 7.01275H7.30836V3.74806H5.68211V7.01275H3.25548L6.4968 10.2527L9.74773 7.01275Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
          {!showLess && documentCollection.length > 2 && (
            <button
              style={{
                padding: "0px",
                border: "none",
                background: "none",
                fontWeight: "600",
                color: "#487ED8",
                width: "fit-content",
              }}
              onClick={() => {
                setShowMore(false);
                setShowLess(true);
              }}
            >
              Show more
            </button>
          )}
          {!showMore && documentCollection.length > 2 && (
            <button
              style={{
                padding: "0px",
                border: "none",
                background: "none",
                fontWeight: "600",
                color: "#487ED8",
                width: "fit-content",
              }}
              onClick={() => {
                setShowLess(false);
                setShowMore(true);
              }}
            >
              Show less
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default DocumentCollectionData;
